import { loadStripe, type Stripe } from "@stripe/stripe-js";

const stripeByKey = new Map<string, Promise<Stripe | null>>();

export function getStripeBrowser(publishableKey: string): Promise<Stripe | null> {
  let p = stripeByKey.get(publishableKey);
  if (!p) {
    p = loadStripe(publishableKey);
    stripeByKey.set(publishableKey, p);
  }
  return p;
}
